import logo from './logo_transparent.png'

import colorLogo from './logo_transparent1.png'
import {useCookies} from "react-cookie";

const Nav = ({authToken,minimal, setShowModal, showModal, setIsSignUp}) => {
    const [cookies, setCookie, removeCookie] = useCookies(['user'])

    const handleClick = () => {

        setShowModal(true)
        setIsSignUp(false)


    }
    return (
        <nav>
            <div className={'logo-container'}>
                <img className={'logo'} src={minimal ? logo : colorLogo} alt=""/>
            </div>

            {!authToken &&
            <button className={'nav-button'}
                    onClick={handleClick}
                    disabled={showModal}
            >Log in</button>}
        </nav>
    )
}

export default Nav